import { apiSlice } from "api/apiSlice";

import {
    createSelector,
    createEntityAdapter,
} from "@reduxjs/toolkit";

const orderAdapter = createEntityAdapter({
    /*eslint-disable*/
    // sortComparer: (a, b) => (a.isDelivered === b.isDelivered) ? 0 : a.isDelivered ? 1 : -1
})

export const formatter = currency => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency || 'USD'
});

export const statusTable =  [{status: "En attente", color :"warning", stage : 0, icon : "schedule" }, {status: "Vu", color :"dark", stage : 1, icon : "notifications" } ,{status : "Acceptée", color :"info", stage : 2, icon:"inventory_2"} ,{status : "Rejetée", color :"error", stage : 3, icon : "cancel"}, {status : "En route" , color:"secondary", stage : 4, icon:"local_shipping"} , {status : "Délivrée", color : "primary", stage : 5, icon : "done"},{status : "Payée", color : "success", stage :6, icon : "handshake" }];

function getStagePriority(entry) {
  let color = 0;
  let stepDate ;
  if (entry.isPaid) {
    color = 6; // Payment is received
    stepDate = entry.paidAt;
  } else if (entry.isDelivered) {
    color = 5; // The order is delivered
    stepDate = entry.deliveredAt;
  } else if (entry.isCouriers) {
    color = 4; // The order is delivered
    stepDate = entry.couriersAt;
  } else if (entry.isAccepted) {
    color = entry.isAccepted === 2 ? 3 : 2; // The request is accepted
    stepDate = entry.updatedAt;
  } else if (entry.isSeen) {
    color = 1; // The message is seen
    stepDate = entry.updatedAt;
  } 
  return {...statusTable[color], stepDate : stepDate ?? entry.createdAt };
}

const initialState = orderAdapter.getInitialState({
    ordersDetails : {
        page: 0,
        filters: {},
        ordersPerpage: 20,
        total_results: 0
    }
})

export const orderApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getOrder: builder.query({
            query: params => ({ url: `orders`, params }),
            validateStatus: (response, result) => response.status === 200 && !result.isError,
            transformResponse: responseData => {
                const loadedOrder = responseData.orders.map(order => {
                    /* eslint-disable */
                    const neworder = order;
                    neworder.totalPrice    = formatter('DZD').format(order.totalPrice)
                    neworder.itemsPrice    = formatter('DZD').format(order.itemsPrice)
                    neworder.shippingPrice = formatter('DZD').format(order.shippingPrice)
                    neworder.taxesPrice      = formatter('DZD').format(order.taxesPrice)
                    neworder.stampPrice      = formatter('DZD').format(order.stampPrice || 0)
                    neworder.step = getStagePriority(order);
                    neworder.isPaid = Boolean( order.isPaid === 1 );
                    return neworder
                });
                initialState.ordersDetails = {
                    ...initialState.ordersDetails,
                        page: responseData.page,
                        filters: responseData.filters ,
                        ordersPerpage: responseData.ordersPerpage,
                        total_results: responseData.total_results
                }
                return orderAdapter.setAll(initialState, loadedOrder)
            },
            /* eslint-disable */
            providesTags: (result, error, id) => // [{ type: 'Order', arg }]
             {
                /* eslint-disable */
                if (result?.ids) {
                    return [
                        { type: 'Order', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'Order', id }))
                    ]
                } else return [{ type: 'Order', id: 'LIST' }]
            }
        }),
        getUserOrder: builder.query({
            query: params => ({ url: `userOrder`, params }),
            validateStatus: (response, result) => response.status === 200 && !result.isError,
            transformResponse: responseData => {
                const loadedOrder = responseData.orders.map(order => {
                    /* eslint-disable */
                    const neworder = order;
                    neworder.totalPrice    = formatter('DZD').format(order.totalPrice)
                    neworder.itemsPrice    = formatter('DZD').format(order.itemsPrice)
                    neworder.shippingPrice = formatter('DZD').format(order.shippingPrice)
                    neworder.taxesPrice      = formatter('DZD').format(order.taxesPrice)
                    neworder.stampPrice      = formatter('DZD').format(order.stampPrice || 0)
                    neworder.step = getStagePriority(order);
                    neworder.isPaid = Boolean( order.isPaid === 1 );
                    return neworder
                });
                return {
                    ...responseData,
                    orders : loadedOrder
                }
            },
            /* eslint-disable */
            providesTags: (result, error, id) => {
                if (result?.ids) {
                    return [
                        { type: 'Order', id: 'LIST' },  // Tag for the list of orders
                        ...result.ids.map(id => ({ type: 'Order', id }))  // Tag for individual orders
                    ];
                } else {
                    return [{ type: 'Order', id: 'LIST' }];
                }
            },
        }),
        getOrderInvoice: builder.query({
            query: (id) => ({ url: `generate-invoice/${id}` }),
            validateStatus: (response, result) => response.status === 200 && !result.isError,
            transformResponse: responseData =>  responseData,
            /* eslint-disable */
        }),
        addNewOrder: builder.mutation({
            query: initialOrderData => ({
                url: '/order',
                method: 'POST',
                body: {
                    ...initialOrderData,
                }
            }),
            invalidatesTags: [
                { type: 'Order', id: "LIST" }
            ]
        }),
        updateOrder: builder.mutation({
            query: initialOrderData => ({
                url: '/order',
                method: 'PATCH',
                body: {
                    ...initialOrderData,
                }
            }),
            invalidatesTags: (result, error, arg) => {
                // Invalidate both the specific order and the 'LIST' of orders
                return [
                    { type: 'Order', id: 'LIST' },  // Invalidate the order list
                    { type: 'Order', id: arg.id }   // Invalidate the specific order being updated
                ];
            }
        }),
        deleteOrder: builder.mutation({
            query: ({ id }) => ({
                url: `/order`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Order', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetOrderQuery,
    useLazyGetOrderInvoiceQuery,
    useGetUserOrderQuery,
    useAddNewOrderMutation,
    useUpdateOrderMutation,
    useDeleteOrderMutation,
} = orderApiSlice

// returns the query result object
export const selectOrderResult = orderApiSlice.endpoints.getOrder.select()

// creates memoized selector
const selectOrderData = createSelector(
    selectOrderResult,
    orderResult => orderResult.data // normalized state object with ids & entities
)
//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllOrder,
    selectById: selectOrderById,
    selectIds: selectOrderIds
    // Pass in a selector that returns the order slice of state
} = orderAdapter.getSelectors(state => selectOrderData(state) ?? initialState)

export const selectOrderByUser = createSelector(
    [selectAllOrder,(state, userId) => userId],
    (orders, userId) => orders.find(order => order.userId === userId)
);

